// extracted by mini-css-extract-plugin
export var router_item = "index-module--router_item--4892d";